@if (component) {
<div class="p-t-10 p-b-10 p-t-8-s p-b-8-s p-t-8-m p-b-8-m wrap">
    <!-- text -->
    @if(component.display_text_component){
    <div class="w-12 flex flex-justify-center flex-justify-start-s flex-justify-start-m m-b-8 m-b-1-s m-b-1-m">
        <p [ngClass]="component.text_style_heading|| 'h1'"
           *iCms="'heading' of component"></p>
    </div>
    }

    @if(component.services?.length)
    {
    @if(client.isX || client.isL){
    <div class="flex flex-justify-center">
        @for (service of component.services; track service) {
        <div class="c-3 m-r-10 m-b-0">
            <href [link]="service?.link">
                <div class="center flex-column flex-middle height-100">
                    <div class="m-b-2">
                        <!-- alt="" is deliberate: the title and description
                             below already name this service -->
                        <img [dfImage]="service.image"
                             [ratio]="1"
                             [width]="52"
                             alt="">
                    </div>
                    <p class="m-b-1 h2"
                       *iCms="'title' of service"></p>
                    <p class="p2"
                       *iCms="'description' of service; skipEmpty: true"></p>
                    @if(service.button_text){
                    <button type="button"
                            class="m-t-2"
                            [buttonStyle]="service?.button_style || 'button'">
                        <span *iCms="'button_text' of service;"></span>
                    </button>}
                </div>
            </href>
        </div>
        }
    </div>
    }@else {
    <div class="flex-column flex-top">
        @for (service of component.services; track service) {
        <href [link]="service?.link">
            <div class="flex b-t b-col-5 p-t p-b"
                 [ngClass]="!$last ? 'b-b' : ''"
                 [style]="client.isM ? 'width: 696px' : ''">
                <div class="m-r"
                     style="flex-shrink: 0;">
                    <img [ratio]="1"
                         [width]="32"
                         [dfImage]="service.image"
                         alt="">
                </div>
                <div>
                    <p class="m-b-1 h3"
                       *iCms="'title' of service"></p>
                    <p class="p2"
                       *iCms="'description' of service; skipEmpty: true"></p>
                    @if(service.button_text){
                    <button class="m-t-1"
                            type="button"
                            [buttonStyle]="service?.button_style || 'button'">
                        <span *iCms="'button_text' of service;"></span>
                    </button>}
                </div>
            </div>
        </href>
        }
    </div>
    }
    }
</div>
}